export const toastOk = 'success'
export const toastInfo = 'info'
export const toastWarn = 'warning'
export const toastNok = 'error'